import { createContext } from "react"
import type { TUserSession } from "@/types"

export const UserSessionContext = createContext<TUserSession | null>(null)
